<button class="exit-button" mat-raised-button mat-dialog-close><mat-icon matTooltip="Click to close">clear</mat-icon></button>
<iframe
  [src]="bbbURL | safe"
  allow="camera *; microphone *;"
  allowfullscreen
  sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups"
  *ngIf="!isLoading && data.checkType === 0"
></iframe>
<div *ngIf="!isLoading && data.checkType === 1" style="padding-top: 56.25%; position: relative; width: 100%;">
  <iframe
    allowfullscreen
    src="https://embed.contentflow.net/output/pRLGDaegZ9376FoJp8l6"
    style="background-color: transparent; border: none; height: 100%; position: absolute; top: 0; width: 100%;"
  ></iframe>
</div>

<iframe
  src="https://check.streavent.de"
  allow="camera *; microphone *;"
  allowfullscreen
  sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-popups allow-downloads"
  *ngIf="!isLoading && data.checkType === 2"
></iframe>
<mat-spinner *ngIf="isLoading"></mat-spinner>
